import React from 'react';
import { useStore } from '../context/StoreContext';
import SafeIcon from '../common/SafeIcon';
import { APP_VIEW_DASHBOARD, APP_VIEW_BOARD } from '../constants';

const MobileBottomNav = ({ onMore }) => {
  const { viewMode, setViewMode, setIsPaletteOpen } = useStore();

  const items = [
    { id: 'home', label: 'Home', icon: 'Home', active: viewMode === APP_VIEW_DASHBOARD, action: () => setViewMode(APP_VIEW_DASHBOARD) },
    { id: 'notes', label: 'Notes', icon: 'FileText', active: [APP_VIEW_BOARD, 'list', 'timeline'].includes(viewMode), action: () => setViewMode(APP_VIEW_BOARD) },
    { id: 'capture', label: 'Capture', icon: 'Zap', capture: true, action: () => window.dispatchEvent(new CustomEvent('stickyhq:open-quick-capture')) },
    { id: 'search', label: 'Search', icon: 'Search', action: () => setIsPaletteOpen(true) },
    { id: 'more', label: 'More', icon: 'Menu', action: onMore }
  ];

  return (
    <nav
      aria-label="Primary mobile navigation"
      className="fixed inset-x-0 bottom-0 z-[70] border-t border-gray-200/90 bg-white/95 backdrop-blur-xl shadow-[0_-10px_30px_rgba(15,23,42,0.08)] safe-bottom"
    >
      <div className="mx-auto grid h-[68px] max-w-lg grid-cols-5 px-1">
        {items.map(item => (
          <button
            key={item.id}
            type="button"
            onClick={item.action}
            className={`relative min-h-[56px] min-w-[56px] px-1 flex flex-col items-center justify-center gap-1 rounded-2xl transition active:scale-95 ${item.active ? 'text-blue-600' : 'text-gray-500'}`}
            aria-label={item.label}
          >
            <span className={`flex items-center justify-center ${item.capture ? 'w-12 h-12 -mt-5 rounded-2xl bg-blue-600 text-white shadow-lg shadow-blue-200' : 'w-8 h-8'}`}>
              <SafeIcon name={item.icon} className={item.capture ? 'text-[24px]' : 'text-[25px]'} />
            </span>
            <span className={`text-[11px] leading-none font-bold ${item.capture ? '-mt-0.5 text-blue-700' : ''}`}>{item.label}</span>
            {item.active && !item.capture && <span className="absolute top-1.5 w-5 h-0.5 rounded-full bg-blue-600" />}
          </button>
        ))}
      </div>
    </nav>
  );
};

export default MobileBottomNav;